var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaTerror1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.683 112.951C170.683 152.752 142.821 172.653 109.707 184.196C107.973 184.783 106.089 184.755 104.373 184.116C71.1787 172.653 43.3176 152.752 43.3176 112.951V57.2286C43.3176 55.1174 44.1563 53.0927 45.6491 51.5998C47.142 50.107 49.1667 49.2683 51.2779 49.2683C67.1986 49.2683 87.0993 39.7159 100.95 27.6163C102.637 26.1754 104.782 25.3838 107 25.3838C109.218 25.3838 111.364 26.1754 113.05 27.6163C126.98 39.7955 146.802 49.2683 162.722 49.2683C164.833 49.2683 166.858 50.107 168.351 51.5998C169.844 53.0927 170.683 55.1174 170.683 57.2286V112.951Z",
    fill: "url(#paint0_linear_2162_30709)",
    stroke: "url(#paint1_linear_2162_30709)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3475 77.8475C91.6922 72.5027 98.9413 69.5 106.5 69.5C114.059 69.5 121.308 72.5027 126.653 77.8475C131.997 83.1922 135 90.4413 135 98V140.75L124.312 130.062L115.406 138.969L106.5 130.062L97.5938 138.969L88.6875 130.062L78 140.75V98C78 90.4413 81.0027 83.1922 86.3475 77.8475Z",
    fill: "#D9D9D9",
    stroke: "#393939",
    strokeWidth: 7.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114 110.5C114 116.575 110.866 116 107 116C103.134 116 100 116.575 100 110.5C102 103 103.134 99.5 107 99.5C110.866 99.5 112 102.5 114 110.5Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.742 95.2482C97.5002 101.014 93.4847 98.9835 91.9845 97.9831C90.4844 96.9828 87.4846 93.9825 90.9845 90.9828C94.4844 87.9831 96.3017 82.3418 98.8931 82.3416C101.484 82.3415 103.984 89.4826 100.742 95.2482Z",
    fill: "#393939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.626 95.2482C114.868 101.014 118.883 98.9835 120.383 97.9831C121.884 96.9828 124.883 93.9825 121.383 90.9828C117.884 87.9831 116.066 82.3418 113.475 82.3416C110.883 82.3415 108.384 89.4826 111.626 95.2482Z",
    fill: "#393939"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0327 207.253V227.616H79.2088L68.858 212.682H68.669V227.616H65.5966V207.253H68.4403L78.8011 222.207H78.9901V207.253H82.0327ZM86.2759 227.616V212.343H89.2489V227.616H86.2759ZM86.5543 210.305L88.881 205.721H92.0131L88.9308 210.305H86.5543ZM106.314 212.343L100.776 227.616H97.5938L92.0455 212.343H95.2372L99.1051 224.096H99.2642L103.122 212.343H106.314ZM115.171 227.924C113.666 227.924 112.37 227.603 111.283 226.96C110.203 226.31 109.367 225.399 108.777 224.226C108.194 223.046 107.902 221.664 107.902 220.079C107.902 218.515 108.194 217.136 108.777 215.943C109.367 214.75 110.189 213.818 111.243 213.149C112.304 212.479 113.543 212.145 114.962 212.145C115.824 212.145 116.659 212.287 117.468 212.572C118.276 212.857 119.002 213.305 119.645 213.915C120.288 214.524 120.795 215.316 121.167 216.291C121.538 217.259 121.723 218.435 121.723 219.821V220.875H109.583V218.647H118.81C118.81 217.865 118.651 217.173 118.333 216.569C118.015 215.959 117.567 215.479 116.99 215.128C116.42 214.776 115.751 214.601 114.982 214.601C114.147 214.601 113.417 214.806 112.794 215.217C112.178 215.621 111.701 216.152 111.363 216.808C111.031 217.458 110.865 218.164 110.865 218.926V220.666C110.865 221.687 111.044 222.555 111.402 223.271C111.767 223.987 112.274 224.534 112.924 224.912C113.573 225.283 114.332 225.468 115.201 225.468C115.764 225.468 116.278 225.389 116.742 225.23C117.206 225.064 117.607 224.819 117.945 224.494C118.283 224.169 118.542 223.768 118.721 223.291L121.534 223.798C121.309 224.627 120.905 225.352 120.321 225.976C119.745 226.592 119.019 227.073 118.144 227.417C117.275 227.755 116.284 227.924 115.171 227.924ZM127.995 207.253V227.616H125.022V207.253H127.995ZM147.091 207.253V227.616H144.009V210.335H143.889L139.017 213.517V210.574L144.098 207.253H147.091Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30709",
    x1: 107,
    y1: 25.3838,
    x2: 107,
    y2: 184.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30709",
    x1: 107,
    y1: 25.3838,
    x2: 107,
    y2: 184.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804A01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaTerror1);
export default __webpack_public_path__ + "static/media/Medalha_terror_1.926b3e44714cec2ce7717b32d17efd8a.svg";
export { ForwardRef as ReactComponent };